import axios from 'axios';
import { API_URL as BASE_API_URL } from '../config/apiConfig';
import { getDriverAuthHeaders } from '../utils/driverAuthUtils';

const API_URL = `${BASE_API_URL}/driver/auth`;

/**
 * Verify driver token with the server
 * @param {Object} driverAuthState - The driverAuth state from Redux
 * @returns {Promise<boolean>} - True if token is valid on server
 */
export const verifyDriverToken = async (driverAuthState) => {
  try {
    const headers = getDriverAuthHeaders(driverAuthState);
    
    const response = await axios.get(`${API_URL}/verify`, {
      headers,
      timeout: 5000 // 5 second timeout
    });
    
    return response.data.valid === true;
  } catch (error) {
    console.error('Driver token verification failed:', error.message);
    return false;
  }
};

/**
 * Get current driver profile to verify authentication
 * @param {Object} driverAuthState - The driverAuth state from Redux
 * @returns {Promise<Object|null>} - Driver profile or null if invalid
 */
export const getCurrentDriverProfile = async (driverAuthState) => {
  try {
    const headers = getDriverAuthHeaders(driverAuthState);
    
    const response = await axios.get(`${API_URL}/profile`, {
      headers,
      timeout: 5000
    });
    
    return response.data.driver || response.data;
  } catch (error) {
    console.error('Failed to get current driver profile:', error.message);
    return null;
  }
};

/**
 * Refresh driver authentication data
 * @param {Object} driverAuthState - The driverAuth state from Redux
 * @returns {Promise<Object|null>} - Refreshed auth data or null if invalid
 */
export const refreshDriverAuth = async (driverAuthState) => {
  try {
    const headers = getDriverAuthHeaders(driverAuthState);
    
    const response = await axios.post(`${API_URL}/refresh`, {}, {
      headers,
      timeout: 5000
    });
    
    return response.data;
  } catch (error) {
    console.error('Failed to refresh driver authentication:', error.message);
    return null;
  }
};

export default {
  verifyDriverToken,
  getCurrentDriverProfile,
  refreshDriverAuth
};
